import { render } from "./StudentRequirementsDataTable.vue?vue&type=template&id=5d1fdb02&scoped=true"
import script from "./StudentRequirementsDataTable.vue?vue&type=script&lang=js"
export * from "./StudentRequirementsDataTable.vue?vue&type=script&lang=js"

import "./StudentRequirementsDataTable.vue?vue&type=style&index=0&id=5d1fdb02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1fdb02"]])

export default __exports__